export function getOS(): string | null {
  var userAgent = window.navigator.userAgent,
    platform = window.navigator.platform,
    macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
    windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
    iosPlatforms = ['iPhone', 'iPad', 'iPod'],
    os = null;
  if (macosPlatforms.indexOf(platform) !== -1) {
    os = 'Mac OS';
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    os = 'iOS';
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = 'Windows';
  } else if (/Android/.test(userAgent)) {
    os = 'Android';
  } else if (!os && /Linux/.test(platform)) {
    os = 'Linux';
  }
  return os;
}

export function getBrowsers() {
  // Get the user-agent string
  let userAgentString = navigator.userAgent;

  // Detect Chrome
  let chromeAgent = userAgentString.indexOf('Chrome') > -1;

  // Detect Internet Explorer
  let IExplorerAgent = userAgentString.indexOf('MSIE') > -1 || userAgentString.indexOf('rv:') > -1;

  // Detect Firefox
  let firefoxAgent = userAgentString.indexOf('Firefox') > -1;

  // Detect Safari
  let safariAgent = userAgentString.indexOf('Safari') > -1;

  // Detect Opera
  let operaAgent = userAgentString.indexOf('OP') > -1;

  // Discard Safari since it also matches Chrome
  if (chromeAgent && safariAgent) safariAgent = false;

  // Discard Chrome since it also matches Opera
  if (chromeAgent && operaAgent) chromeAgent = false;
  return {
    isChrome: chromeAgent,
    isIE: IExplorerAgent,
    isFirefox: firefoxAgent,
    isSafari: safariAgent,
    isOpera: operaAgent,
    otherElse: !chromeAgent && !IExplorerAgent && !firefoxAgent && !safariAgent && !operaAgent,
  };
}

export function iOSDevice(): boolean {
  return getOS() === 'iOS';
}

export function iOSMacOsDevice(): boolean {
  return getOS() === 'Mac OS';
}

export function runningInTheMobileApp(): boolean {
  return typeof (window as any).AppLogoffCall !== 'undefined';
}
